import React from 'react';

import HelpExpanderInline from '@helsenorge/designsystem-react/components/HelpExpanderInline';

import SafeHTML from '@helsenorge/framework-utils/components/safe-html';

type Props = {
  helpText: string;
  opening: boolean;
};

const HelpElement = ({ helpText, opening }: Props): React.JSX.Element => {
  return <HelpExpanderInline expanded={opening}>{<SafeHTML testId="help-element" html={helpText} />}</HelpExpanderInline>;
};
export default HelpElement;
